export const CREATE_INVOICE = "CREATE_INVOICE";
export const EDIT_INVOICE = "EDIT_INVOICE";
export const DELETE_INVOICE = "DELETE_INVOICE";
export const TOGGLE_FILTER = "TOGGLE_FILTER";
